import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id 9B72D845-E704-489C-A447-D02306AF5228
 * name patreon
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/patreon.svg
 * tags
 * - Brand / Logo 
 */
export const PatreonIcon = createSvgIcon(<><path d="M14.82 2.41C18.78 2.41 22 5.65 22 9.62C22 13.58 18.78 16.8 14.82 16.8C10.85 16.8 7.61 13.58 7.61 9.62C7.61 5.65 10.85 2.41 14.82 2.41M2 21.6H5.5V2.41H2V21.6Z" /></>, 'PatreonIcon');
export default PatreonIcon